module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "solution"
  }, [_c('div', {
    staticClass: "head",
    style: ({
      backgroundImage: 'url(' + _vm.img.headBg + ')'
    })
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v("同品牌公司一样，享有最专业的私有云解决方案")]), _vm._v(" "), _c('p', [_vm._v("账号与权限管理是身份认证和访问权限控制的服务；适用于同一组织下多成员共同管理云计算资源及财务信息的场景；可授予不同成员于不同的资源操作权限。利于企业规划管理及成员权限")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.fnToRouter('/404')
      }
    }
  }, [_vm._v("开启私有云")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tabs",
    attrs: {
      "id": "tabs"
    }
  }, [_c('el-tabs', {
    class: {
      fixed: _vm.isFixed
    },
    on: {
      "tab-click": _vm.tabClick
    },
    model: {
      value: (_vm.tab_active),
      callback: function($$v) {
        _vm.tab_active = $$v
      },
      expression: "tab_active"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "2_1",
      "label": "热门方案"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "2_2",
      "label": "行内方案"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "2_3",
      "label": "受益客户"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('tab_1')], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('div', [_vm._v("我们以用户的需求主导产品研发，提供丰富、高性能、稳定的产品和服务")]), _vm._v(" "), _c('tab_2')], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('tab_3')], 1)])], 1), _vm._v(" "), _c('foot')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "tab1"
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("热门解决方案")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "tab2"
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("行内解决方案")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "tab3"
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("受益客户")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-543c8bb3"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Solution.vue
// module id = 786
// module chunks = 1